import { Button } from '../../../common/Button';
import { Icon } from '../../../common/Icon';

export function CheckInSuggestion({
  suggestion,
  setSuggestion,
}: {
  suggestion: string;
  setSuggestion: () => void;
}): JSX.Element {
  return (
    <div className="rounded-md w-full bg-[#F5F3FF] p-2 space-y-3">
      <div className="flex justify-between items-center">
        <span className="text-[#361D50] flex items-center gap-2">
          <Icon name="magic" className="w-4 h-4" />
          AI suggestion
        </span>
        <div className="flex gap-2">
          {/* <Button //todo: bring back after getting the usecase
            type="button"
            variant="outline"
            size="base"
            className="text-[#56416C] rounded-md w-fit h-fit py-1 px-2 text-sm bg-transparent border-none hover:bg-[#56416C] hover:text-white"
          >
            Ignore this
          </Button> */}
          <Button
            type="button"
            variant="outline"
            onClick={setSuggestion}
            size="base"
            className="rounded-md w-fit h-fit py-1 px-2 text-sm  border-none bg-[#56416C] text-white"
          >
            Use this
          </Button>
        </div>
      </div>
      <div className="text-sm bg-white rounded-md p-2 text-[#291640]">
        {suggestion}
      </div>
    </div>
  );
}
